<div class="w-2/3 flex flex-col gap-6">
	<h2 class="">Datos Generales</h2>

	@if (user(); as user) {
		<activar-info-card>
			@if (user.badgeStatus) {
				<div class="card__text">
					<span>Estado:</span>
					<activar-badge
						[text]="user.badgeText"
						[status]="user.badgeStatus" />
				</div>
			}

			<div class="card__text">
				<span>Email:</span>
				<span class="card__text__info">{{ user.email }}</span>
			</div>

			@if (user.identification) {
				<div class="card__text">
					<span>Documento:</span>
					<span class="card__text__info">{{
						formatIdentification(user)
					}}</span>
				</div>
			}

			@if (user.address) {
				<div class="card__text">
					<span>Dirección:</span>
					<span class="card__text__info capitalize">{{
						user.address
					}}</span>
				</div>
			}

			@if (user.postalCode && user.postalCode !== 'undefined') {
				<div class="card__text">
					<span>Código Postal:</span>
					<span class="card__text__info capitalize">{{
						user.postalCode
					}}</span>
				</div>
			}

			@if (user.birthDate) {
				<div class="card__text">
					<span>Fecha de Nacimiento:</span>
					<span class="card__text__info">{{
						user.birthDate | date: 'dd/MM/yyyy'
					}}</span>
				</div>
			}
			@if (user.role === 'AGENT') {
				<div class="card__text">
					<span>Matrícula:</span>
					<span class="card__text__info">{{
						user.insuranceNumberArgentina | number
					}}</span>
				</div>
				<div class="card__text">
					<span>Código en Meridional:</span>
					<span class="card__text__info">{{
						user.insuranceNumberMeridional | number
					}}</span>
				</div>
			}
		</activar-info-card>



			@if (user.agent; as agent) {
				<div class="info__card flex flex-row justify-between" *showForRole="['SUPERADMIN', 'ADMIN']">
					<div class="section">
						<p class="label">Productor</p>
						<p class="value">
							@if(agent.user.companyName){
								{{ agent.user.companyName }}
							}@else{
								{{ agent.user.firstName }}
								{{ agent.user.lastName }}
							}

						</p>
					</div>
					@if (isSuperAdmin()) {
						<button
							class="border border-gray-300 text-gray-700 px-4 py-1 rounded-md hover:bg-gray-100 transition-colors font-semibold"
							(click)="onEdit()">
							Editar
						</button>
					}
				</div>
			}


	}
</div>
